import {
  ChatTextMessageOutput,
  ChatUIEnhancementMessage,
  UIEnhancementType,
  MessageContent,
  ChatUIEnhancementContentCard,
  ChatUIEnhancementCategoryCard,
} from 'Assistant/__generated__/client.schemas';
import { AssistantSourceChunk } from '../types';

const isObject = (v: unknown): v is Record<string, unknown> =>
  v !== null && typeof v === 'object';

export const isMessageContent = (v: unknown): v is MessageContent =>
  isObject(v) &&
  'body' in v &&
  typeof (v as { body?: unknown }).body === 'string';

export const isStreamingText = (v: unknown): v is ChatTextMessageOutput =>
  isObject(v) &&
  'value' in v &&
  (v as { type?: unknown }).type !== 'ui_enhancement' && // ui enhancements always carry subtype
  ((v as { type?: unknown }).type === undefined ||
    (v as { type?: unknown }).type === 'text');

export const isUiEnhancement = (v: unknown): v is ChatUIEnhancementMessage =>
  isObject(v) &&
  (v as { type?: unknown }).type === 'ui_enhancement' &&
  'subtype' in v &&
  'value' in v;

export const mapAssistantPayloadToSource = (
  payload: unknown,
): AssistantSourceChunk | null => {
  if (isMessageContent(payload)) {
    return { kind: 'text', value: payload.body };
  }

  if (isStreamingText(payload)) {
    if (typeof payload.value !== 'string' || payload.value.length === 0)
      return null;

    return { kind: 'text', value: payload.value };
  }

  if (isUiEnhancement(payload)) {
    switch (payload.subtype) {
      case UIEnhancementType.content_card:
        return {
          kind: 'content_card',
          value: payload.value as ChatUIEnhancementContentCard,
        };
      case UIEnhancementType.category_card:
        return {
          kind: 'category_card',
          value: payload.value as ChatUIEnhancementCategoryCard,
        };
      default:
        return {
          kind: 'text',
          value: JSON.stringify(payload),
        };
    }
  }

  if (typeof payload === 'string') {
    return payload.length ? { kind: 'text', value: payload } : null;
  }
  if (payload == null) return null;

  return { kind: 'text', value: JSON.stringify(payload) };
};
